// --------------------------------------------------------------
// Created On: 2025-11-04
// Author: Zachary Thomas
//
// Last Modified: 2025-11-04
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialState = false;
const localStorageValue = localStorage.getItem("reduxNewPasswordRequired");
if (localStorageValue === "true") {
  initialState = true;
}

// A Redux slice for the mobile app to be able to communicate that a new password is required.
const mobileNewPasswordRequiredSlice = createSlice({
  name: "mobileNewPasswordRequired",
  initialState,
  reducers: {
    setMobileNewPasswordRequired: (state, action: PayloadAction<boolean>) => {
      if (action.payload === true) {
        localStorage.setItem("reduxNewPasswordRequired", "true");
      } else {
        localStorage.setItem("reduxNewPasswordRequired", "false");
      }
      return action.payload;
    },
  },
});

export const { setMobileNewPasswordRequired } = mobileNewPasswordRequiredSlice.actions;
export default mobileNewPasswordRequiredSlice.reducer;
